module.exports = __webpack_public_path__ + "assets/img/tutorial3_1.3e46d221.png";